// components/EnrichedRequisitesTable.tsx
import { paymentRequisitsColumns, useEnrichedPaymentRequisites } from '@/entities/paymentRequisit'

import { RequisiteModel } from '@/features/requisites'
import { SmallBaseTableSkeleton } from './SmallBaseTableSkeleton'
import { BaseTable } from 'syncra-storybook/features'

type Props = {
  requisit: RequisiteModel
  onDisable: (id: string) => void
  onEnable: (id: string) => void
}

export const EnrichedRequisitesTable = ({ requisit, onDisable, onEnable }: Props) => {
  const { enriched, isLoading, isError } = useEnrichedPaymentRequisites(
    requisit.paymentRequisitProfiles
  )

  if (isLoading) {
    return <SmallBaseTableSkeleton />
  }

  if (isError || enriched.length === 0) {
    return (
      <p className="flex justify-center items-center w-full h-4">Нет данных или ошибка загрузки.</p>
    )
  }

  return (
    <BaseTable
      columns={paymentRequisitsColumns({
        onDisable,
        onEnable,
        maxDailyLimit: requisit.maxDailyLimit ?? 0,
      })}
      data={enriched}
      cardPadding="sm"
    />
  )
}
